export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Řádek od"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["do"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["znaků"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neplatná hodnota"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Povinné pole"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zkontrolujte pole"])}
}